(function () {
  'use strict';

  var carouselIndex = 0;
  var enhancementQueued = false;

  function labelForCarousel(carousel) {
    if (carousel.matches('.product-gallery__main')) return 'Product images';
    if (carousel.matches('.product-gallery__thumbnails')) return 'Product image thumbnails';
    if (carousel.matches('.text-slideshow')) return 'Customer story carousel';
    if (carousel.matches('.main-blog__featured-videos-inner')) return 'Helpful videos';
    if (carousel.matches('._mb-owl-carousel')) {
      var carouselType = carousel.getAttribute('data-owl-carousel');
      if (carouselType === 'about') return 'How Mosie works';
      if (carouselType === 'timing') return 'Insemination timing';
      return 'Customer review videos';
    }
    return 'Featured content carousel';
  }

  function statusForCarousel(carousel, label) {
    var nextSibling = carousel.nextElementSibling;
    if (nextSibling && nextSibling.hasAttribute('data-mosie-carousel-status')) return nextSibling;

    carouselIndex += 1;
    var status = document.createElement('p');
    status.className = 'visuallyhidden';
    status.id = 'mosie-carousel-status-' + carouselIndex;
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    status.setAttribute('data-mosie-carousel-status', '');
    carousel.insertAdjacentElement('afterend', status);
    carousel.setAttribute('aria-describedby', status.id);
    return status;
  }

  function isOwlCarousel(carousel) {
    return carousel.classList.contains('_mb-owl-carousel');
  }

  function slideCount(carousel) {
    var dots = carousel.querySelectorAll('.flickity-page-dots .dot, .owl-dots .owl-dot');
    if (dots.length) return dots.length;

    if (isOwlCarousel(carousel)) {
      return carousel.querySelectorAll('.owl-stage > .owl-item:not(.cloned)').length;
    }

    return carousel.querySelectorAll('.flickity-slider > *').length;
  }

  function selectedSlide(carousel) {
    var selectedDot = carousel.querySelector('.flickity-page-dots .dot.is-selected, .owl-dots .owl-dot.active');
    if (!selectedDot) return 0;

    return Array.prototype.indexOf.call(selectedDot.parentNode.children, selectedDot);
  }

  function updateStatus(carousel, label, status) {
    var total = slideCount(carousel);
    var index = selectedSlide(carousel) + 1;
    var dots = carousel.querySelectorAll('.flickity-page-dots .dot, .owl-dots .owl-dot');

    dots.forEach(function (dot, dotIndex) {
      var isCurrent = dotIndex === index - 1;
      dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
      dot.setAttribute('aria-label', 'Show ' + label + ' slide ' + (dotIndex + 1) + ' of ' + total);
    });

    var message = total ? label + ': slide ' + index + ' of ' + total : label;
    if (status.textContent !== message) status.textContent = message;
  }

  function setControlLabels(carousel, label) {
    carousel.querySelectorAll('.flickity-button.previous').forEach(function (button) {
      button.setAttribute('aria-label', 'Previous ' + label + ' slide');
    });
    carousel.querySelectorAll('.flickity-button.next').forEach(function (button) {
      button.setAttribute('aria-label', 'Next ' + label + ' slide');
    });
    carousel.querySelectorAll('.owl-nav .owl-prev').forEach(function (button) {
      button.setAttribute('aria-label', 'Previous ' + label + ' slide');
    });
    carousel.querySelectorAll('.owl-nav .owl-next').forEach(function (button) {
      button.setAttribute('aria-label', 'Next ' + label + ' slide');
    });
  }

  function makeDotsKeyboardAccessible(carousel) {
    carousel.querySelectorAll('.flickity-page-dots .dot').forEach(function (dot) {
      dot.setAttribute('role', 'button');
      dot.tabIndex = 0;
      if (dot.dataset.mosieDotKeyboard === 'true') return;

      dot.dataset.mosieDotKeyboard = 'true';
      dot.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        dot.click();
      });
    });
  }

  function watchSlideChanges(carousel, label, status) {
    if (carousel.dataset.mosieCarouselChanges === 'true') return;
    carousel.dataset.mosieCarouselChanges = 'true';

    function refreshStatus() {
      window.requestAnimationFrame(function () {
        updateStatus(carousel, label, status);
      });
    }

    if (window.Flickity && typeof window.Flickity.data === 'function') {
      var flickity = window.Flickity.data(carousel);
      if (flickity && typeof flickity.on === 'function') flickity.on('select', refreshStatus);
    }

    if (window.jQuery && isOwlCarousel(carousel)) {
      window.jQuery(carousel).on('changed.owl.carousel.mosieAccessibility', refreshStatus);
    }

    // Both libraries update selection classes, including after a drag or autoplay.
    new MutationObserver(refreshStatus).observe(carousel, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  function enhanceCarousel(carousel) {
    var label = labelForCarousel(carousel);
    var status = statusForCarousel(carousel, label);

    carousel.setAttribute('data-mosie-carousel', 'true');
    carousel.setAttribute('role', 'region');
    carousel.setAttribute('aria-roledescription', 'carousel');
    carousel.setAttribute('aria-label', label);
    carousel.removeAttribute('tabindex');
    setControlLabels(carousel, label);
    makeDotsKeyboardAccessible(carousel);
    updateStatus(carousel, label, status);
    watchSlideChanges(carousel, label, status);

    if (carousel.dataset.mosieCarouselEvents === 'true') return;
    carousel.dataset.mosieCarouselEvents = 'true';

    carousel.addEventListener('click', function (event) {
      if (!event.target.closest('.flickity-button, .flickity-page-dots .dot, .owl-nav button, .owl-dots .owl-dot')) return;
      window.setTimeout(function () {
        updateStatus(carousel, label, status);
      }, 50);
    });
  }

  function enhanceCarousels() {
    enhancementQueued = false;
    var selectors = [
      '.text-slideshow.flickity-enabled',
      '.fa-carousel .gallery.flickity-enabled',
      '.product-gallery__main.flickity-enabled',
      '.product-gallery__thumbnails.flickity-enabled',
      '.main-blog__featured-videos-inner[plug-videos].flickity-enabled',
      '[data-owl-carousel]._mb-owl-carousel.owl-loaded'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(enhanceCarousel);
  }

  function queueEnhancement() {
    if (enhancementQueued) return;
    enhancementQueued = true;
    window.requestAnimationFrame(enhanceCarousels);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var skipLink = document.querySelector('.mosie-skip-link');
    var mainContent = document.getElementById('MainContent') || document.querySelector('main');

    if (skipLink && mainContent) {
      skipLink.addEventListener('click', function (event) {
        if (!document.getElementById('MainContent')) {
          event.preventDefault();
          mainContent.scrollIntoView();
        }
        window.requestAnimationFrame(function () {
          mainContent.focus({ preventScroll: true });
        });
      });
    }

    enhanceCarousels();
    new MutationObserver(queueEnhancement).observe(document.body, { childList: true, subtree: true });
  });
})();
